import '../../styles/_OTPInput.scss';

import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import cryptoJS from 'crypto-js';
import { goToErrorsView, setPageName } from 'actions/errorViewNavigation';
import { formatText, FormattedText } from 'core/i18n';
import {
    recordedAddJointHoldersPage,
    getRecordedJointHoldersConfirmationPage,
    recordedJointHoldersConfirmationPage,
    recordEventStepSuccess,
    recordEvent,
    errorTag,
    PAGE_PRODUCT,
} from 'utilities/uTagging';
import { doTagPageOtpView } from './tagging';
import classNames from 'classnames';
import Headline from 'components/headline';
import { RoadmapNavigation } from 'components/steps/RoadmapNavigation/RoadmapNavigation';
import { InputText } from 'components/inputText/inputText';
import { actions as formActions } from 'react-redux-form';
import stepsActions from 'actions/stepsActions';
import optionsActions from 'actions/optionsActions';
import focusActions from 'actions/focusActions';
import ibanActions from 'actions/ibanActions';
import jointHoldersActions from 'actions/jointHoldersActions';
import jointHoldersStatusActions from 'actions/jointHoldersStatusActions';
import standByActions from 'actions/standByActions';
import createActions from 'actions/createActions';
import { ERROR_AL_ENVIAR_INVITACION } from 'constants/analyticsErrors';
import { PATH_JOINHOLDER_CONFIRMATION } from 'constants/uTagConstants/paths';

class OtpView extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isValidOTP: false,
            loadingOTPCode: false,
            loadingReloadOTPCode: false,
        };

        this.onHandlePrevious = this.onHandlePrevious.bind(this);
        this.onHandleValidateOTP = this.onHandleValidateOTP.bind(this);
        this.reloadOTPCode = this.reloadOTPCode.bind(this);
        this.sendPendingMails = this.sendPendingMails.bind(this);
    }

    gotoNextStep() {
        const { actions, immStepsState } = this.props;
        const currentIndex = immStepsState.get('currentStep');
        this.setState({ isClicked: false });
        actions.finalizeStep({
            index: currentIndex,
            finished: true,
        });
        actions.enableFinishedAndNextStep();
        actions.changeCurrentStep({
            index: currentIndex + 1,
        });
    }

    onHandlePrevious() {
        const { formActions } = this.props;
        window.scrollTo(0, 0);
        recordedAddJointHoldersPage(false);
        formActions.reset('userProfile.otpCode');
        formActions.change('userProfile.showOTP', false);
        formActions.change('userProfile.showJointHolder', true);
    }

    onHandleValidateOTP() {
        const { userProfile, formActions, jointHoldersActions } = this.props;
        const { docNumber } = userProfile;
        const docNumberEncrypted = docNumber ? cryptoJS.SHA256(docNumber).toString() : '';
        const otpCode = userProfile.otpCode ? userProfile.otpCode.toUpperCase() : '';
        const accessToken = userProfile.accessToken;

        this.setState({ loadingOTPCode: true });
        jointHoldersActions.verifyOtp({ otp: otpCode }, accessToken, (valid, error) => {
            this.setState({ loadingOTPCode: false });
            if (valid) {
                this.sendPendingMails();
            } else if (error === 1) {
                formActions.setValidity('userProfile.otpCode', { obsolete: false });
            } else {
                formActions.setValidity('userProfile.otpCode', { valid: false });
            }
            recordEvent(
                PATH_JOINHOLDER_CONFIRMATION,
                PAGE_PRODUCT,
                'intervinientes',
                'ERROR EN OTP',
                '',
                '',
                '',
                userProfile.investmentType,
                docNumberEncrypted
            );
            errorTag(error.body, PATH_JOINHOLDER_CONFIRMATION, ERROR_AL_ENVIAR_INVITACION, error.statusCode);
        });
    }

    sendPendingMails() {
        const { userProfile, jointHoldersActions, actions, formActions, goToErrorsView } = this.props;
        const accessToken = userProfile.accessToken;
        const { docNumber } = userProfile;
        const docNumberEncrypted = docNumber ? cryptoJS.SHA256(docNumber).toString() : '';

        jointHoldersActions.sendPendingInvitation(accessToken, valid => {
            if (!valid) {
                recordEvent(
                    PATH_JOINHOLDER_CONFIRMATION,
                    PAGE_PRODUCT,
                    'intervinientes',
                    ERROR_AL_ENVIAR_INVITACION,
                    '',
                    '',
                    '',
                    userProfile.investmentType,
                    docNumberEncrypted
                );
                errorTag({}, PATH_JOINHOLDER_CONFIRMATION, ERROR_AL_ENVIAR_INVITACION);
                goToErrorsView({ errorMessage: ERROR_AL_ENVIAR_INVITACION });
            } else {
                this.setState({ isValidOTP: true });
                formActions.change('userProfile.jointHolderDecisionDisabled', true);
                formActions.change('userProfile.isJointHolderAccount', true);
                formActions.resetValidity('userProfile.otpCode');
                setTimeout(() => {
                    this.gotoNextStep();
                    formActions.change('userProfile.showOTP', false);
                    formActions.change('userProfile.otpCode', '');
                }, 1000);
                recordEvent(
                    PATH_JOINHOLDER_CONFIRMATION,
                    PAGE_PRODUCT,
                    'intervinientes',
                    'codigo otp correcto',
                    '',
                    '',
                    '',
                    userProfile.investmentType,
                    docNumberEncrypted
                );

                recordEventStepSuccess(
                    userProfile.investmentType,
                    '/onboarding/intervinientes/confirmacion',
                    'confirmacion intervinientes'
                );
                actions.clientCardConfigVerify(accessToken);
            }
        });
    }

    buildOTPLoading() {
        return (
            <div className="joint-holder__otp-reload">
                <span className="icons--icon-otp-loading"></span>
            </div>
        );
    }

    buildOTPInput() {
        const { userProfile, userProfileForm, formActions, products, setPageName } = this.props;
        const iconClass = classNames(
            { 'icons--icon-check': this.state.isValidOTP },
            { hidden: !this.state.isValidOTP }
        );
        const reloadOTPCode = this.reloadOTPCode;

        if (!getRecordedJointHoldersConfirmationPage()) {
            recordedJointHoldersConfirmationPage();
            setPageName(doTagPageOtpView({ userProfile, products }));
        }

        return (
            <div className="prospects-gutter prospects-separator otp-block">
                <div className="form__input">
                    <label className="top-label">
                        <FormattedText value="otp-confirmationCode" />
                    </label>
                    <br />
                    <label className="sub-label">
                        <FormattedText value="otp-enterCode" />
                    </label>
                </div>
                <div className="promo-code__input row">
                    <div className="col-xs-9 col-sm-6">
                        <InputText
                            profileModel={'userProfile.otpCode'}
                            id="otpCode"
                            type="text"
                            messagesError={{
                                valid: formatText('validation-otpInvalid'),
                                obsolete: formatText('validation-otpObsolete'),
                            }}
                            userProfile={userProfile}
                            formActions={formActions}
                            userProfileForm={userProfileForm}
                        />
                    </div>
                    <div className="col-xs-2 col-sm-2">
                        <span className={iconClass}></span>
                    </div>
                </div>

                <hr />
                <p className="prospects-disclaimer">
                    <FormattedText value="stepsTitles-jointHolderDataDisclaimerOTP1" />
                    <a
                        className="otp-block__link"
                        href="#"
                        onClick={event => {
                            event.preventDefault();
                            reloadOTPCode();
                        }}
                    >
                        <FormattedText value="stepsTitles-jointHolderDataDisclaimerOTP2" />
                    </a>
                    <FormattedText value="stepsTitles-jointHolderDataDisclaimerOTP3" />
                </p>
            </div>
        );
    }

    reloadOTPCode() {
        const { userProfile, formActions, jointHoldersActions } = this.props;
        const accessToken = userProfile.accessToken;

        formActions.change('userProfile.otpCode', '');
        formActions.resetValidity('userProfile.otpCode');
        this.setState({ loadingReloadOTPCode: true });

        jointHoldersActions.getNewOtp(accessToken, valid => {
            if (valid) {
                setTimeout(() => {
                    this.setState({ loadingReloadOTPCode: false, loadingOTPCode: false });
                }, 200);
            }
        });
    }

    render() {
        const buildOTP = this.state.loadingReloadOTPCode ? this.buildOTPLoading() : this.buildOTPInput();

        return (
            <div className="joint-holder__otp">
                <Headline icon="holders" className="prospects-gutter">
                    <h2>
                        <FormattedText value="initial-jointHolderAccountOTP" />
                    </h2>
                    <p>
                        <FormattedText value="initial-jointHolderAccountOTPText" />
                    </p>
                </Headline>

                {buildOTP}

                <div className="form__footer">
                    <RoadmapNavigation
                        buttonPrevSpecialHidden
                        buttonPrevHidden
                        buttonPrevAction={this.onHandlePrevious}
                        buttonContinueAction={this.onHandleValidateOTP}
                        buttonContinueLoading={this.state.loadingOTPCode}
                        buttonContinueDisabled={this.state.loadingReloadOTPCode}
                    />
                </div>
            </div>
        );
    }
}

module.exports.constructor = OtpView;
module.exports.OtpView = connect(
    state => ({
        userProfile: state.userProfile,
        extraData: state.extraData,
        userProfileForm: state.userProfileForm,
        immStepsState: state.steps,
        options: state.options,
        focus: state.focus,
        products: state.products,
    }),
    dispatch => ({
        actions: bindActionCreators(stepsActions, dispatch),
        formActions: bindActionCreators(formActions, dispatch),
        ibanActions: bindActionCreators(ibanActions, dispatch),
        optionsActions: bindActionCreators(optionsActions, dispatch),
        jointHoldersActions: bindActionCreators(jointHoldersActions, dispatch),
        focusActions: bindActionCreators(focusActions, dispatch),
        standByActions: bindActionCreators(standByActions, dispatch),
        jointHoldersStatusActions: bindActionCreators(jointHoldersStatusActions, dispatch),
        createActions: bindActionCreators(createActions, dispatch),
        goToErrorsView: bindActionCreators(goToErrorsView, dispatch),
        setPageName: bindActionCreators(setPageName, dispatch),
    })
)(OtpView);
